import NoData from '@monorepo/common/component/NoData';
import QueryWithLoader from '@monorepo/common/component/QueryWithLoader';
import ResponsiveHeaderRow from '@monorepo/common/component/responsive/ResponsiveHeaderRow';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { DisciplineDocument, DisciplineQuery, DisciplineQueryVariables } from '../../graphql-operations';
import DisciplineDetailPeriodView from './DisciplineDetailPeriodView';
import { NewDisciplineIcon } from './DisciplineDetailView';

interface DisciplineDetailProps {
  disciplineId?: string;
  listUrl: string;
}

export default function DisciplineDetail({ disciplineId, listUrl }: DisciplineDetailProps) {
  return (
    <>
      {/*Top header for small screens to go back to list*/}
      <ResponsiveHeaderRow to={listUrl}>
        <NewDisciplineIcon />
      </ResponsiveHeaderRow>

      {!!disciplineId && (
        <QueryWithLoader<DisciplineQuery, DisciplineQueryVariables>
          query={DisciplineDocument}
          variables={{ id: disciplineId }}
        >
          {({ data }) => {
            const discipline = data.discipline;

            if (!discipline) {
              return <Redirect to="/page-not-found" />;
            }

            return <DisciplineDetailPeriodView discipline={discipline} />;
          }}
        </QueryWithLoader>
      )}

      {!disciplineId && <NoData text="Vyberte oddíl" />}
    </>
  );
}
